import React from 'react';
import Icon from '../AppIcon';
import useTranslation from '../../hooks/useTranslation';

export const ONX_AVATAR = '/assets/images/onx-avatar.png';

/** En-tete de la page OnX : avatar, nom, statut, bouton « Nouveau chat ». */
const OnXHeader = ({ onNewConversation, disabled = false }) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-between px-6 py-3 border-b border-gray-200 bg-background flex-shrink-0">
      <div className="flex items-center gap-3 min-w-0">
        <img
          src={ONX_AVATAR}
          alt={t('sidebar.onx')}
          draggable={false}
          className="w-10 h-10 rounded-full object-cover flex-shrink-0 select-none"
        />
        <div className="min-w-0">
          <h1 className="text-lg font-semibold text-[#2C3E50] leading-tight">{t('sidebar.onx')}</h1>
          <div className="flex items-center gap-2 text-xs text-muted-foreground">
            <span className="truncate">{t('onx.subtitle')}</span>
            <span className="flex items-center gap-1 flex-shrink-0">
              <span className="w-1.5 h-1.5 rounded-full bg-green-500" />
              {t('onx.online')}
            </span>
          </div>
        </div>
      </div>

      <button
        type="button"
        onClick={onNewConversation}
        disabled={disabled}
        className="flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-medium text-gray-700 border border-gray-200 hover:bg-gray-50 transition-colors disabled:opacity-40 disabled:cursor-not-allowed flex-shrink-0"
      >
        <Icon name="MessageSquarePlus" size={16} />
        <span>{t('onx.newChat')}</span>
      </button>
    </div>
  );
};

export default OnXHeader;
